/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetOrderKindsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetOrderKindsResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/order-kinds
 */
export interface OrderKindsRequestBuilder extends BaseRequestBuilder<OrderKindsRequestBuilder> {
    /**
     * Returns every order kind the platform defines, with the family it belongs to and a one-line description. An organization names its own order types, but each one maps to exactly one of these kinds — read the list from here rather than hardcoding it, because the set is closed and grows only with a platform release.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetOrderKindsResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetOrderKindsResponse | undefined>;
    /**
     * Returns every order kind the platform defines, with the family it belongs to and a one-line description. An organization names its own order types, but each one maps to exactly one of these kinds — read the list from here rather than hardcoding it, because the set is closed and grows only with a platform release.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OrderKindsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/order-kinds";
/**
 * Metadata for all the requests in the request builder.
 */
export const OrderKindsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OrderKindsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetOrderKindsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
